import React, { useRef, useState, useContext } from 'react';
import {
  View, Text, FlatList, Alert, Image, Pressable, LayoutAnimation,
  Modal, TouchableOpacity, Dimensions, StyleSheet,
} from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import { useNavigation } from '@react-navigation/native';
import {
  Appbar, Dialog, Portal, Button, IconButton, Avatar,
} from 'react-native-paper';
import Constants from 'expo-constants';
import * as FileSystem from 'expo-file-system';
import * as Sharing from 'expo-sharing';
import QRCode from 'react-native-qrcode-svg';
import Logo from '../../assets/logo.png';
import { GET_BAG_DETAILS } from '../../gql/bag/query';
import { AllUsersQuery } from '../../gql/user/query';
import { GET_CURRENT_SEASON } from '../../gql/season/query';
import { RENT_BAG, RETURN_BAG, CANCEL_RENTAL } from '../../gql/bag/mutation';
import { REMOVE_EQUIPMENT_FROM_BAG } from '../../gql/equipment/mutation';
import { styles } from './BagDetailsScreen.style';
import { SCREEN_NAMES } from '../../utils/constant';
import BagDialogs from './BagDialogs';
import EquipmentOnBagDialog from './EquipmentOnBagDialog';
import EquipmentOnBagHistoryDialog from './EquipmentOnBagHistoryDialog';
import QualityGradeInfo, { qualityGradeColors } from '../../components/commons/QualityGradeInfo';
import { ModalContext } from '../../context/ModalContext';
import { AuthContext } from '../../context/AuthContext';
import ConfirmationModal from '../../modals/Confirmation/ConfirmationModal';
import InformationModal from '../../modals/Information/InformationModal';
import RefreshableScreen from '../Refreshable/RefreshableScreen';
import LoadingIndicator from '../../components/commons/LoadingIndicator';

const fullScreenStyles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    width: Dimensions.get('window').width,
    height: Dimensions.get('window').height,
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: Dimensions.get('window').width * 0.95,
    height: Dimensions.get('window').height * 0.8,
  },
  closeButton: {
    position: 'absolute',
    top: 40,
    right: 20,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    borderRadius: 25,
  },
});

function BagDetailsScreen({ route }) {
  const { qrCode } = route.params;
  const navigation = useNavigation();
  const {
    toggleConfirmationModal,
    displayConfirmationModal,
    displayInformationModal,
  } = useContext(ModalContext);
  const { authState } = useContext(AuthContext);

  if (!authState.authenticated) {
    return (
      <View style={styles.container}>
        <Appbar.Header>
          <Appbar.Content title="Equipement" />
        </Appbar.Header>
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
          <Text style={{ fontSize: 18, textAlign: 'center', marginHorizontal: 20 }}>
            Ce sac appartient au 'Karaté Club Bethoncourt'.
          </Text>
          <Text style={{
            fontSize: 16, textAlign: 'center', marginHorizontal: 20, marginTop: 10,
          }}
          >
            Contact: contact@karateclubbethoncourt.fr
          </Text>
        </View>
      </View>
    );
  }

  const [qrCodeVisible, setQrCodeVisible] = useState(false);
  const [equipmentOnBagDialogVisible, setEquipmentOnBagDialogVisible] = useState(false);
  const [selectedEquipmentOnBag, setSelectedEquipmentOnBag] = useState(null);
  const [equipmentOnBagHistoryDialogVisible, setEquipmentOnBagHistoryDialogVisible] = useState(false);
  const [selectedEquipmentOnBagHistory, setSelectedEquipmentOnBagHistory] = useState(null);
  const [expandedRentals, setExpandedRentals] = useState({});
  const [fullScreenImageUri, setFullScreenImageUri] = useState(null);

  const showQrCode = () => setQrCodeVisible(true);
  const hideQrCode = () => setQrCodeVisible(false);

  const showEquipmentOnBagDialog = (equipmentOnBag) => {
    setSelectedEquipmentOnBag(equipmentOnBag);
    setEquipmentOnBagDialogVisible(true);
  };

  const hideEquipmentOnBagDialog = () => {
    setSelectedEquipmentOnBag(null);
    setEquipmentOnBagDialogVisible(false);
  };

  const showEquipmentOnBagHistoryDialog = (history) => {
    setSelectedEquipmentOnBagHistory(history);
    setEquipmentOnBagHistoryDialogVisible(true);
  };

  const hideEquipmentOnBagHistoryDialog = () => {
    setSelectedEquipmentOnBagHistory(null);
    setEquipmentOnBagHistoryDialogVisible(false);
  };

  const {
    data, loading, error, refetch,
  } = useQuery(GET_BAG_DETAILS, {
    variables: { qrCode },
  });

  const {
    data: usersData,
  } = useQuery(AllUsersQuery);

  const { data: dataSeason } = useQuery(GET_CURRENT_SEASON);
  const season = dataSeason?.findCurrentSeason;

  const [rentBag] = useMutation(RENT_BAG);
  const [returnBag] = useMutation(RETURN_BAG);
  const [cancelRental] = useMutation(CANCEL_RENTAL);
  const [removeEquipmentFromBag] = useMutation(REMOVE_EQUIPMENT_FROM_BAG, {
    update(cache, { data: { removeEquipmentFromBag: removedEquipment } }) {
      cache.modify({
        id: cache.identify(bag),
        fields: {
          equipments(existingEquipments = [], { readField }) {
            return existingEquipments.filter(
              (equipmentRef) => readField('equipmentId', equipmentRef) !== removedEquipment.equipmentId,
            );
          },
        },
      });
    },
  });
  const ref = useRef(undefined);

  const [rentDialogVisible, setRentDialogVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [returnDialogVisible, setReturnDialogVisible] = useState(false);
  const [rentalToReturnId, setRentalToReturnId] = useState(null);
  const [depositReturned, setDepositReturned] = useState(false);
  const [returnComment, setReturnComment] = useState('');
  const [returnPicture, setReturnPicture] = useState(null);
  const [rentalComment, setRentalComment] = useState('');
  const [rentalPicture, setRentalPicture] = useState(null);

  const showRentDialog = () => {
    setRentDialogVisible(true);
  };
  const hideRentDialog = () => {
    setRentDialogVisible(false);
    setSelectedUser(null);
    setSearchQuery('');
    setRentalComment('');
    setRentalPicture(null);
  };

  const showReturnDialog = (rentalId) => {
    setRentalToReturnId(rentalId);
    setReturnDialogVisible(true);
  };
  const hideReturnDialog = () => {
    setRentalToReturnId(null);
    setReturnDialogVisible(false);
    setDepositReturned(false);
    setReturnComment('');
    setReturnPicture(null);
  };

  const handleRent = async () => {
    try {
      if (bag && selectedUser) {
        // Extract base64 from picture if present
        let pictureBase64 = null;
        if (rentalPicture && rentalPicture.uri) {
          if (rentalPicture.uri.startsWith('data:image')) {
            const [, base64Data] = rentalPicture.uri.split(',');
            pictureBase64 = base64Data;
          } else {
            pictureBase64 = rentalPicture.uri;
          }
        }

        await rentBag({
          variables: {
            bagId: bag.id,
            userId: selectedUser.id,
            depositPaid: true,
            rentalComment: rentalComment || null,
            rentalPicture: pictureBase64,
          },
        });
        refetch();
        hideRentDialog();
      }
    } catch (e) {
      Alert.alert('Error', e.message);
    }
  };

  const handleDownload = async (qrcodeName) => {
    if (ref.current) {
      ref.current.toDataURL(async (qrData) => {
        const filename = `qrcode-${qrcodeName}.png`;
        const fileUri = FileSystem.cacheDirectory + filename;
        await FileSystem.writeAsStringAsync(
          fileUri,
          qrData,
          { encoding: FileSystem.EncodingType.Base64 },
        );
        await Sharing.shareAsync(fileUri);
      });
    }
  };

  const handleReturn = async () => {
    try {
      // Extract base64 from picture if present
      let pictureBase64 = null;
      if (returnPicture && returnPicture.uri) {
        if (returnPicture.uri.startsWith('data:image')) {
          const [, base64Data] = returnPicture.uri.split(',');
          pictureBase64 = base64Data;
        } else {
          pictureBase64 = returnPicture.uri;
        }
      }

      await returnBag({
        variables: {
          rentalId: rentalToReturnId,
          depositReturned,
          returnComment: returnComment || null,
          returnPicture: pictureBase64,
        },
      });
      refetch();
      hideReturnDialog();
    } catch (e) {
      Alert.alert('Error', e.message);
    }
  };

  const handleCancelRental = (rentalId) => {
    toggleConfirmationModal({
      title: 'Annuler la location',
      message: 'Etes-vous sûr de vouloir annuler cette location ?',
      handleSubmit: async () => {
        try {
          await cancelRental({
            variables: {
              rentalId,
            },
          });
          refetch();
        } catch (e) {
          Alert.alert('Error', e.message);
        }
      },
    });
  };

  const handleRemoveEquipment = (equipmentId) => {
    console.log('handleRemoveEquipment called for equipmentId:', equipmentId);
    toggleConfirmationModal({
      title: 'Supprimer l\'équipement',
      message: 'Etes-vous sûr de vouloir supprimer cet équipement du sac ?',
      handleSubmit: async () => {
        console.log('Confirmation handleSubmit called.');
        try {
          const response = await removeEquipmentFromBag({
            variables: {
              bagId: bag.id,
              equipmentId,
            },
          });
          console.log('removeEquipmentFromBag response:', response);
          refetch();
          console.log('refetch() called.');
        } catch (e) {
          console.error('Error during removeEquipmentFromBag mutation:', e);
          Alert.alert('Error', e.message);
        }
      },
    });
  };

  if (loading) return <LoadingIndicator text="Chargement des détails du sac..." />;
  if (error) {
    return (
      <Text>
        Error:
        {error.message}
      </Text>
    );
  }

  const bag = data?.bag;

  if (!bag) return <Text>Aucun sac trouvé.</Text>;

  const toggleRentalExpanded = (rentalId) => {
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    setExpandedRentals((prev) => ({
      ...prev,
      [rentalId]: !prev[rentalId],
    }));
  };

  const hasDocumentation = (item) => item.rentalComment || item.rentalPicture || item.returnComment || item.returnPicture;

  const renderRentalItem = ({ item, currentRentalItem }) => {
    const isExpanded = expandedRentals[item.id];
    const hasDoc = hasDocumentation(item);

    return (
      <View style={[styles.rentalItem, item.id === currentRentalItem?.id && styles.highlightedRental]}>
        {/* Header with mandatory info */}
        <Pressable
          onPress={() => hasDoc && toggleRentalExpanded(item.id)}
          style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}
        >
          <View style={{ flex: 1 }}>
            <Text style={styles.rentalDate}>
              {new Date(item.rentalDate).toLocaleDateString()}
              {' '}
              -
              {' '}
              {item.returnDate ? new Date(item.returnDate).toLocaleDateString() : 'En cours'}
            </Text>
            <Text>
              Utilisateur:
              {' '}
              {item.user.firstName}
              {' '}
              {item.user.lastName}
            </Text>
            <Text>
              Caution payée:
              {' '}
              {item.depositPaid ? 'Oui' : 'Non'}
              {' | '}
              Rendue:
              {' '}
              {item.depositReturned ? 'Oui' : 'Non'}
            </Text>
          </View>
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            {hasDoc && (
              <IconButton
                icon={isExpanded ? 'chevron-up' : 'chevron-down'}
                size={20}
                onPress={() => toggleRentalExpanded(item.id)}
              />
            )}
            {!item.returnDate && (
              <IconButton
                icon="cancel"
                size={20}
                onPress={() => handleCancelRental(item.id)}
              />
            )}
          </View>
        </Pressable>

        {/* Collapsible documentation section */}
        {isExpanded && hasDoc && (
          <View style={{ marginTop: 10, paddingTop: 10, borderTopWidth: 1, borderTopColor: '#e0e0e0' }}>
            {/* Rental documentation */}
            {(item.rentalComment || item.rentalPicture) && (
              <View style={{ marginBottom: 10 }}>
                <Text style={{ fontWeight: '600', color: '#4CAF50', marginBottom: 5 }}>
                  📦 À la location:
                </Text>
                {item.rentalComment && (
                  <Text style={{ marginLeft: 10, fontStyle: 'italic', color: '#666' }}>
                    {item.rentalComment}
                  </Text>
                )}
                {item.rentalPicture && (
                  <Pressable
                    onPress={() => setFullScreenImageUri(`data:image/jpeg;base64,${item.rentalPicture}`)}
                  >
                    <Image
                      source={{ uri: `data:image/jpeg;base64,${item.rentalPicture}` }}
                      style={{
                        width: 150, height: 150, marginLeft: 10, marginTop: 5, borderRadius: 8,
                      }}
                    />
                  </Pressable>
                )}
              </View>
            )}

            {/* Return documentation */}
            {(item.returnComment || item.returnPicture) && (
              <View>
                <Text style={{ fontWeight: '600', color: '#2196F3', marginBottom: 5 }}>
                  📥 Au retour:
                </Text>
                {item.returnComment && (
                  <Text style={{ marginLeft: 10, fontStyle: 'italic', color: '#666' }}>
                    {item.returnComment}
                  </Text>
                )}
                {item.returnPicture && (
                  <Pressable
                    onPress={() => setFullScreenImageUri(`data:image/jpeg;base64,${item.returnPicture}`)}
                  >
                    <Image
                      source={{ uri: `data:image/jpeg;base64,${item.returnPicture}` }}
                      style={{
                        width: 150, height: 150, marginLeft: 10, marginTop: 5, borderRadius: 8,
                      }}
                    />
                  </Pressable>
                )}
              </View>
            )}
          </View>
        )}
      </View>
    );
  };

  const currentRental = bag.rentals.find((rental) => !rental.returnDate);
  const isRented = !!currentRental;

  return (
    <>
      <Appbar.Header statusBarHeight={0}>
        <Appbar.Content title={`${bag.name}`} />
        <Appbar.Action
          icon="qrcode"
          onPress={showQrCode}
        />
        {!isRented ? (
          <Appbar.Action
            icon="hand-coin"
            onPress={showRentDialog}
          />
        ) : (
          <Appbar.Action
            icon="undo"
            onPress={() => showReturnDialog(currentRental.id)}
          />
        )}
      </Appbar.Header>
      <RefreshableScreen onRefresh={() => refetch()}>
        <View style={styles.container}>
          {displayConfirmationModal.display && <ConfirmationModal />}
          {displayInformationModal.display && <InformationModal />}

          <Text>
            Identifiant:
            {' '}
            {bag.qrCode}
          </Text>
          <Text>
            Montant de la caution:
            {' '}
            {bag.depositAmount}
            {' '}
            €
          </Text>

          <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <QualityGradeInfo style={{ alignSelf: 'center' }} />
              <Text style={[styles.subtitle, { marginRight: 8 }]}>Equipements:</Text>
            </View>
            <IconButton
              icon="plus"
              onPress={() => navigation.navigate(SCREEN_NAMES.ASSIGN_EQUIPMENT_TO_BAG, { bagId: bag.id, qrCode: bag.qrCode, refetchBagDetails: refetch })}
              style={{ marginRight: 0, padding: 0 }}
            />
          </View>
          {bag.equipments.length > 0 ? (
            <FlatList
              data={bag.equipments}
              keyExtractor={(item) => item.equipment.id.toString()}
              renderItem={({ item }) => (
                <View style={{
                  flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingVertical: 8,
                }}
                >
                  <View style={{ flexDirection: 'row', alignItems: 'center', flexShrink: 1 }}>
                    {item.qualityGrade && (
                      <Avatar.Text
                        size={24}
                        label={item.qualityGrade}
                        style={{ backgroundColor: qualityGradeColors[item.qualityGrade] || '#9E9E9E', marginRight: 8 }}
                        labelStyle={{ color: 'white', fontSize: 12 }}
                      />
                    )}
                    <Text style={{ flexShrink: 1 }} numberOfLines={2} ellipsizeMode="tail">
                      -
                      {' '}
                      {item.equipment.name}
                      {' '}
                      (
                      {item.equipment.size}
                      )
                    </Text>
                  </View>
                  <View style={{ flexDirection: 'row' }}>
                    <IconButton
                      icon="history"
                      onPress={() => showEquipmentOnBagHistoryDialog(item.history)}
                    />
                    <IconButton
                      icon="pencil"
                      onPress={() => showEquipmentOnBagDialog(item)}
                    />
                    <IconButton
                      icon="delete"
                      onPress={() => handleRemoveEquipment(item.equipment.id)}
                    />
                  </View>
                </View>
              )}
            />
          ) : (
            <Text>Aucun équipement.</Text>
          )}

          <Text style={styles.subtitle}>Historique des locations:</Text>
          {bag.rentals.length > 0 ? (
            <FlatList
              data={bag.rentals.slice().reverse()}
              keyExtractor={(item) => item.id.toString()}
              renderItem={({ item }) => renderRentalItem({ item, currentRentalItem: currentRental })}
            />
          ) : (
            <Text>Aucun historique.</Text>
          )}

          <Portal>
            <Dialog visible={qrCodeVisible} onDismiss={hideQrCode}>
              <Dialog.Content>
                <View style={{ alignItems: 'center' }}>
                  <QRCode
                    getRef={ref}
                    logo={Logo}
                    value={`${Constants.experienceUrl}/${encodeURIComponent(SCREEN_NAMES.BAG_DETAILS)}?qrCode=${bag.qrCode}`}
                    size={300}
                    logoBorderRadius={15}
                    logoMargin={1}
                  />
                </View>
                <View style={{ flexDirection: 'row', justifyContent: 'space-around', marginTop: 10 }}>
                  <Button
                    icon="download"
                    onPress={() => handleDownload(bag.name)}
                  >
                    Télécharger
                  </Button>
                </View>
              </Dialog.Content>
            </Dialog>
          </Portal>

          <BagDialogs
            dialogVisible={false}
            hideDialog={() => { }}
            currentBag={bag}
            depositAmount={bag.depositAmount.toString()}
            setDepositAmount={() => { }}
            handleSave={() => { }}
            rentDialogVisible={rentDialogVisible}
            hideRentDialog={hideRentDialog}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            usersData={usersData}
            season={season}
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
            handleRent={handleRent}
            deleteDialogVisible={false}
            hideDeleteDialog={() => { }}
            confirmDelete={() => { }}
            returnDialogVisible={returnDialogVisible}
            hideReturnDialog={hideReturnDialog}
            depositReturned={depositReturned}
            setDepositReturned={setDepositReturned}
            returnComment={returnComment}
            setReturnComment={setReturnComment}
            returnPicture={returnPicture}
            setReturnPicture={setReturnPicture}
            handleReturn={handleReturn}
            rentalComment={rentalComment}
            setRentalComment={setRentalComment}
            rentalPicture={rentalPicture}
            setRentalPicture={setRentalPicture}
          />

          {selectedEquipmentOnBag && (
            <EquipmentOnBagDialog
              visible={equipmentOnBagDialogVisible}
              onDismiss={hideEquipmentOnBagDialog}
              equipmentOnBag={selectedEquipmentOnBag}
              refetch={refetch}
            />
          )}

          {selectedEquipmentOnBagHistory && (
            <EquipmentOnBagHistoryDialog
              visible={equipmentOnBagHistoryDialogVisible}
              onDismiss={hideEquipmentOnBagHistoryDialog}
              history={selectedEquipmentOnBagHistory}
            />
          )}
        </View>
      </RefreshableScreen>

      {/* Full-screen image modal */}
      <Modal
        visible={!!fullScreenImageUri}
        transparent
        animationType="fade"
        onRequestClose={() => setFullScreenImageUri(null)}
      >
        <TouchableOpacity
          style={fullScreenStyles.overlay}
          activeOpacity={1}
          onPress={() => setFullScreenImageUri(null)}
        >
          <View style={fullScreenStyles.container}>
            <Image
              source={{ uri: fullScreenImageUri }}
              style={fullScreenStyles.image}
              resizeMode="contain"
            />
            <TouchableOpacity
              style={fullScreenStyles.closeButton}
              onPress={() => setFullScreenImageUri(null)}
            >
              <IconButton icon="close" iconColor="white" size={30} />
            </TouchableOpacity>
          </View>
        </TouchableOpacity>
      </Modal>
    </>
  );
}

export default BagDetailsScreen;
